export { IxFilterSelect } from './IxFilterSelect.js';
